import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ticketsQueryKey } from '../queries/useTickets'
import { TicketCreateInput, TicketDetail } from '../types'

export function useCreateTicket() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function createTicket(input: TicketCreateInput) {
    const formData = new FormData()
    formData.append('title', input.title)
    formData.append('description', input.description)
    formData.append('category', input.category)
    formData.append('priority', input.priority)
    input.attachments.forEach((file) => formData.append('attachments', file))

    const res = await apiClient.post<TicketDetail>(
      `${SNA_PREFIX}tickets/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return res.data
  }

  return useMutation({
    mutationFn: createTicket,
    onSuccess: () => {
      toast.success({ message: t('ticketCreated') })
      queryClient.invalidateQueries({ queryKey: ticketsQueryKey })
    },
    onError
  })
}
